export type { Pointer } from "@pdfking/wasm-core"
